/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取剧院所有等级id及名称
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.MemberLevelsRes>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/theater/levels`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
